// extracted by mini-css-extract-plugin
export default {"bottomHome":"BottomHome_bottomHome__Vz7+Q"};